<template>
  <div id="app">
    <div v-if="hideWrapper">
      <div class="container-fluid extended">
        <div class="row extended" id="content-body">
          <div
            v-bind:class="{ hidden: !finished, 'col-12': true, extended: true }"
          >
            <router-view @childInitialized="childInitialized"></router-view>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container site-header">
        <div class="row align-items-center pt-md-2">
          <div
            class="col-12 p-0 d-flex flex-row align-items-center justify-content-between"
          >
            <div id="logo" @click="logoClick" class="pointer">
              <img :src="this.skin.logo" :alt="`Logo van ${skin.region}`" />
            </div>

            <div class="d-flex p-0 flex-row align-items-center justify-content-end">
              <div class="col-auto p-0" id="logo-bar">
                <nav class="inline-nav">
                  <button class="hamburger-button" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>

                  <ul class="nav-list" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
                    <li
                      v-for="item in navLinks"
                      :key="item.label"
                      :class="{ dropdown: item.children, open: item.children && openMenu === item.label, active: isActiveNavItem(item) }"
                    >
                      <a
                        :href="item.href"
                        @click="item.children ? toggleDropdown($event, item.label) : null"
                      >{{ item.label }}</a>
                      <ul
                        v-if="item.children"
                        v-show="openMenu === item.label"
                        class="dropdown-list"
                        @click.stop
                      >
                        <li v-for="child in item.children" :key="child.label">
                          <a :href="child.href">{{ child.label }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div
          class="row"
          id="banner"
          :style="`background-image: url('${this.skin.header}');`"
        >
          <div class="col-12">&nbsp;</div>
        </div>
        <div class="row" id="title-banner">
          <div class="col-12 text-center">
            <h1>
              {{ title }}
            </h1>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- Papy Commented To remove read loud-->
        <!--
                <div v-if="skin.readspeaker.active" class="row">
                  <div class="col-12">
                    <div id="readspeaker">
                      <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve">
                        <a rel="nofollow" class="rsbtn_play" accesskey="L" title="Laat de tekst voorlezen met ReadSpeaker webReader" :href="`//app-eu.readspeaker.com/cgi-bin/rsent?customerid=${skin.readspeaker.code}&amp;lang=nl_nl&amp;readid=inner`">
                          <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span>Lees voor</span></span></span>
                          <span class="rsbtn_right rsimg rsplay rspart"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                -->
        <!--<navbar :key="navKey"></navbar>-->
        <div class="row" id="content-body">
          <div v-bind:class="{ hidden: !finished, 'col-12': true }">
            <router-view @childInitialized="childInitialized"></router-view>
          </div>
        </div>
      </div>
      <div class="container-fluid d-none d-lg-block" id="footer">
        <div class="row">
          <div class="col-12 text-center">
            <h2>Heeft u een vraag?</h2>
          </div>
        </div>
        <div class="row">
          <br />
        </div>
        <div class="row">
          <div class="col-12 col-lg-3 offset-lg-3 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <a href="../faq">
                  <i class="fa fax fa-question"></i>
                  <span>Kijk in veelgestelde vragen</span>
                </a>
              </li>
              <li>
                <a :href="`mailto:${skin.contactmail}`">
                  <i class="fa fax fa-envelope"></i>
                  <span>Stuur ons een e-mail</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <a :href="`tel:${skin.contactphone}`">
                  <i class="fa fax fa-phone"></i> <span>Bel gerust</span>
                </a>
              </li>
              <!--<li>
                                <i class="fa  fax fa-newspaper"></i> <span>Ik wil een nieuwsbrief ontvangen</span>
                            </li>-->
            </ul>
          </div>
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row flex-footer">
          <div class="col-12 col-lg-3">
            <h2>Andere diensten?</h2>
            <ul class="list-unstyled">
              <li>
                <a href="https://ruilmijnwoning.nl" target="_blank">
                  Woningruil
                </a>
              </li>
              <!--<li>
                                Urgentie
                            </li>
                            <li>
                                Doorstromers
                            </li>-->
            </ul>
          </div>
          <div class="col-12 col-lg-3" v-if="skin.app === true">
            <h2>Download de App</h2>
            <ul class="list-unstyled list-inline appstore">
              <li class="list-inline-item text-center">
                <a
                  href="https://play.google.com/store/apps/details?id=nl.woonmatch.app.twa"
                  target="_blank"
                >
                  <i class="fab fax fa-android"></i>
                  <p>Android</p>
                </a>
              </li>
              <li class="list-inline-item text-center">
                <a
                  href="https://apps.apple.com/nl/app/woonmatch-app/id1521635724"
                  target="_blank"
                >
                  <i class="fab fax fa-apple"></i>
                  <p>Apple</p>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <h2>Over ons</h2>
            <ul class="list-unstyled">
              <li>
                <a href="../pagina/contact">
                  <span v-if="skin.plural"> De corporaties </span>
                  <span v-else>
                    {{ skin.region }}
                  </span>
                </a>
              </li>
              <li>
                <a href="../pagina/contact"> Contact </a>
              </li>
              <li>
                <a href="../pagina/informatie"> Informatie </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <h2>{{ skin.region }}</h2>
            <p>
              {{ skin.infotext }}
            </p>
          </div>
        </div>
      </div>

      <div class="container-fluid d-block d-lg-none" id="footer-mobile">
        <div class="row">
          <div class="col-12 text-center">
            <h2>Heeft u een vraag aan ons?</h2>
          </div>
        </div>
        <div class="row">
          <br />
        </div>
        <div class="row">
          <div class="col-12 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <i class="fa fax fa-question"></i>
                <a href="../faq">
                  <span>Staat het antwoord in de kennisbank?</span>
                </a>
              </li>
              <li>
                <i class="fad fax fa-envelope"></i>
                <a :href="`mailto:${skin.contactmail}`">
                  <span>Stuur ons een e-mail</span>
                </a>
              </li>
            </ul>
            <ul class="list-unstyled">
              <li>
                <i class="fad fax fa-phone"></i>
                <a :href="`tel:${skin.contactphone}`">
                  <span>Neem gerust contact met ons op</span>
                </a>
              </li>
              <!--<li>
                                <i class="fad fax fa-newspaper"></i> <span>Ik wil de nieuwsbrief</span>
                            </li>-->
            </ul>
          </div>
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row" v-if="skin.app === true">
          <div class="col-12 text-center">
            <h2>Download de App</h2>
            <ul class="list-unstyled list-inline appstore">
              <li class="list-inline-item text-center">
                <i class="fab fax fa-android"></i>
                <p>Android</p>
              </li>
              <li class="list-inline-item text-center">
                <i class="fab fax fa-apple"></i>
                <p>Apple</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
export default {
  name: "app",
  components: { Navbar },
  data: () => {
    return {
      navKey: 0,
      finished: false,
      hideWrapper: false,
      title: "Bezig met laden...",
      openMenu: null,
      isMobileMenuOpen: false,
      navLinks: createNavLinks(),
      skin: {
        logo: process.env.VUE_APP_LOGO,
        header: process.env.VUE_APP_HEADER,
        region: process.env.VUE_APP_REGION,
        plural: process.env.VUE_APP_PLURAL === "true",
        infotext: process.env.VUE_APP_INFOTEXT,
        contactmail: process.env.VUE_APP_CONTACTMAIL,
        contactphone: process.env.VUE_APP_CONTACTPHONE,
        readspeaker: {
          active: process.env.VUE_APP_READSPEAKER === undefined ? false : true,
          code: process.env.VUE_APP_READSPEAKER,
        },
        app: process.env.VUE_APP_HASMOBILE,
      },
    };
  },
  watch: {
    $route() {
      // clear alert on location change
      this.navKey++;
      this.openMenu = null;
      this.isMobileMenuOpen = false;
    },
  },
  methods: {
    childInitialized(data) {
      this.title = data.title;
      this.finished = true;
    },
    logoClick() {
      // const loggedIn = this.$store.state.authentication.status.loggedIn;
      // const aanbod = "../woningaanbod";

      // if (loggedIn) {
      //   window.location.href = siteUrl("/");
      //   return;
      // }

      // const isNewUser = this.$store.state.registration.newUser === true;
      // if (!isNewUser && this.$route.path !== aanbod) {
      //   this.$router.push(aanbod);
      // }
      window.location.href = siteUrl("/");
    },
    toggleDropdown(event, label) {
      if (this.openMenu === label) {
        this.openMenu = null;
        window.location.href = event.currentTarget.href;
      } else {
        event.preventDefault();
        this.openMenu = label;
      }
    },

    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    isActiveNavItem(item) {
      const path = this.$route.path;
      const itemPath = linkPath(item.href);

      if (itemPath === "/inschrijven") {
        return path === "/inschrijven" || path === "/gegevens";
      }

      return itemPath === path;
    },

    closeWerkwijze(event) {
      if (!event.target.closest(".dropdown")) {
        this.openMenu = null;
      }
    },
  },
  mounted() {
    this.hideWrapper = this.$route.meta.hideWrapper || false;

    document.addEventListener("click", this.closeWerkwijze);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeWerkwijze);
  },
};

function siteUrl(path) {
  const baseUrl = process.env.VUE_APP_SITE_URL || "";

  if (!baseUrl) {
    return path;
  }

  return `${baseUrl.replace(/\/$/, "")}${path}`;
}

function linkPath(href) {
  if (!/^https?:\/\//i.test(href)) {
    return href;
  }

  return href.replace(/^https?:\/\/[^/]+/i, "") || "/";
}

function createNavLinks() {
  const isKopNh =
    process.env.VUE_APP_CSS === "kvnh.css" ||
    /kop/i.test(process.env.VUE_APP_REGION || "");
  const isWestFriesland =
    process.env.VUE_APP_CSS === "wmwf.css" ||
    /west-?friesland/i.test(process.env.VUE_APP_REGION || "");

  if (isKopNh) {
    return [
      { label: "HOME", href: siteUrl("/") },
      { label: "INSCHRIJVEN", href: siteUrl("/inschrijven") },
      {
        label: "WERKWIJZE",
        href: siteUrl("/pagina/werkwijze-bij-woningtoewijzing-bij-de-verschillende-corporaties"),
        children: [
          { label: "WONINGBOUWVERENIGING BETER WONEN", href: siteUrl("/pagina/werkwijze-beter-wonen") },
          { label: "WONINGSTICHTING ANNA PAULOWNA", href: siteUrl("/pagina/werkwijze-woningstichting-anna-paulowna") },
          { label: "WONINGSTICHTING DEN HELDER EN HELDER VASTGOED", href: siteUrl("/pagina/wst-den-helder-en-helder-vastgoed-bv-wijzen-toe-o-b-v-reacties-op-de-geadverteerde-woningen") },
          { label: "WOONCOMPAGNIE", href: siteUrl("/pagina/werkwijze-wooncompagnie") },
          { label: "WOONZORG", href: siteUrl("/pagina/werkwijze-woonzorg-nederland") },
        ],
      },
      { label: "VEELGESTELDE VRAGEN", href: siteUrl("/faq") },
      { label: "RUIL MIJN WONING", href: siteUrl("/pagina/ruil-mijn-woning") },
      { label: "VERANTWOORDING", href: siteUrl("/pagina/verantwoording") },
      { label: "CONTACT", href: siteUrl("/pagina/contact") },
    ];
  }

  const defaultLinks = [
    { label: "Home", href: siteUrl("/") },
    { label: "Inschrijven", href: siteUrl("/inschrijven") },
    { label: "Informatie", href: siteUrl("/pagina/informatie") },
    { label: "Veelgestelde vragen", href: siteUrl("/faq") },
    { label: "Verantwoording", href: siteUrl("/pagina/verantwoording") },
    { label: "Contact", href: siteUrl("/pagina/contact") },
  ];

  if (!isWestFriesland) {
    return defaultLinks;
  }

  return [
    ...defaultLinks,
    { label: "Nieuws", href: siteUrl("/nieuws") },
    { label: "Zorgwoningen", href: siteUrl("/zorgwoningen") },
    { label: "Nieuwsbrief 4", href: siteUrl("/pagina/nieuwsbrief-4") },
    { label: "Privacy en disclaimer", href: siteUrl("/pagina/privacy-en-disclaimer") },
  ];
}
</script>

<style scoped>
.extended {
  margin: 0px;
  padding: 0px;
}
@media (max-width: 576px) {
  #banner {
    max-height: 70px;
  }
  #title-banner {
    max-height: 50px;
  }
  #title-banner h1 {
    line-height: 50px;
    font-size: 23px;
  }
}
.flex-footer {
  display: flex;
  justify-content: center;
}

.site-header {
  --nav-color: #19A149;
  padding-top: 19px;
  padding-bottom: 19px;
}

#logo-bar {
  background-color: #fff;
  color: var(--nav-color);
  display: flex;
  justify-content: flex-end;
  flex: 0 1 auto;
}

#logo {
  flex: 0 0 auto;
}

#logo img {
  display: block;
  width: 330px;
  max-width: 400px;
  height: auto;
  margin-top: 10px;
}

.inline-nav .nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(5, max-content);
  column-gap: 26px;
  row-gap: 8px;
  justify-content: flex-end;
}

.nav-list > li {
  padding: 0;
  line-height: 1;
  text-align: center;
}

.nav-list .dropdown {
  position: relative;
}

.nav-list .dropdown-list {
  display: none;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  background-color: #fff;
  border: 1px solid #e3e3e3;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  list-style: none;
  padding: 8px 0;
  margin: 0;
  flex-direction: column;
  z-index: 1000;
  white-space: nowrap;
  min-width: 250px;
}

.nav-list .dropdown.open .dropdown-list,
.nav-list .dropdown-list[style*="display: block"] {
  display: flex;
  align-items: stretch;
}

.nav-list .dropdown.open > a {
  border-color: var(--nav-color);
}

.dropdown-list li + li {
  margin-left: 0 !important;
}

.inline-nav .nav-list a,
.inline-nav .nav-list a:visited,
.inline-nav .nav-list a:hover,
.inline-nav .nav-list a:focus,
.inline-nav .nav-list a:active {
  color: var(--nav-color) !important;
  font-size: 14px !important;
  text-align: center;
  text-decoration: none !important;
  padding: 0 10px 5px;
  border: 1px solid transparent;
  border-bottom: 3px solid transparent;
  font-weight: 400;
  white-space: nowrap;
}

.inline-nav .nav-list > li.active > a {
  outline: 0;
  border-color: transparent;
}

.inline-nav .nav-list a:hover,
.inline-nav .nav-list a:focus {
  border-bottom: 3px solid #6EC05D;
}

.align-items-center {
  align-items: center !important;
}

.dropdown-list li {
  margin: 0;
  line-height: 1.2;
}

.dropdown-list li a {
  display: block;
  padding: 8px 16px;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  border: none !important;
  text-align: left;
}

.hamburger-button {
  display: none;
  position: relative;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1010;
}

.hamburger-button span {
  width: 100%;
  height: 3px;
  background-color: var(--nav-color);
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
  position: relative;
  transform-origin: center;
}

.hamburger-button.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.hamburger-button.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-button.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

@media (max-width: 992px) {
  #logo-bar {
    width: 100%;
    justify-content: flex-end;
    padding: 8px;
    background-color: #fff;
  }

  .hamburger-button {
    display: flex;
  }

  .hamburger-button span {
    width: 100%;
    height: 2px;
    background-color: var(--nav-color);
    border-radius: 2px;
  }

  .inline-nav {
    padding: 0.5rem 1rem;
  }

  .inline-nav .nav-list {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 60px;
    background-color: #fff;
    border-bottom: 1px solid #e3e3e3;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    z-index: 1000;
  }

  .inline-nav .nav-list.mobile-menu-open {
    display: flex;
  }

  .nav-list > li {
    width: 100%;
  }

  .inline-nav .nav-list a {
    border: none;
    border-bottom: 1px solid #e3e3e3;
    text-align: left;
    width: 100%;
  }

  .inline-nav .nav-list > li:last-child > a {
    border-bottom: none;
  }

  .nav-list .dropdown-list {
    position: static;
    display: block;
    background-color: transparent;
    padding-left: 20px;
    min-width: auto;
    border-radius: 0;
  }

  .dropdown-list li a {
    padding: 8px 16px;
    font-size: 13px !important;
    border-bottom: none;
  }
}
</style>
